import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Card, Typography, CircularProgress, Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  vehicleCardHeadline: {
    textAlign: 'center',
  },
  centeredIcon: {
    display: 'flex',
    /**
     * the circular progress is 40px so we need to add 20px to have an image
     * as the other images on ConnectionError and ConnectionSuccessful
     */
    marginTop: `calc(20px + ${theme.spacing(4)})`,
  },
  vehicleCardText: {
    margin: `${theme.spacing(0)} ${theme.spacing(4)} ${theme.spacing(6)} ${theme.spacing(0)}`,
    textAlign: 'center',
  },
  hintCard: {
    marginTop: theme.spacing(2),
  },
  hintHeadline: {
    margin: `${theme.spacing(2)} 0px`,
    color: '#5CC244',
  },
}))

/**
 * Represents the loading screen when trying to connect your vehicle to your power station
 */
const ConnectionLoading: React.VFC = () => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  return (
    <>
      <Card sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress className={classes.centeredIcon} />
        </Box>
        <Typography variant="h2" className={classes.vehicleCardHeadline}>
          {t('emobility.vehicle-integration.connecting-vehicle')}
        </Typography>
        <Typography variant="body2" className={classes.vehicleCardText}>
          {t('emobility.vehicle-integration.connecting-vehicle-discription')}
        </Typography>
      </Card>
      <Card className={classes.hintCard}>
        <Typography variant="h5" className={classes.hintHeadline}>
          {t('emobility.vehicle-integration.hint-headline')}
        </Typography>
        <Typography variant="body2">{t('emobility.vehicle-integration.hint-text')}</Typography>
      </Card>
    </>
  )
}

export default ConnectionLoading
